export const INTRO_CONTROLLER_ID = 'Intro';
export const EVENT_FORM_CONTROLLER_ID = 'EventForm';
export const EVENT_FILTER_CONTROLLER_ID = 'EventFilter';
export const EVALUATION_FORM_CONTROLLER_ID = 'Evaluation';
export const FORM_MODAL_CONTROLLER_ID = 'FormModal';
export const MENU_CONTROLLER_ID = 'Menu';
export const MESSAGES_CONTROLLER_ID = 'Messages';
export const PAGE_SPINNER_CONTROLLER_ID = 'PageSpinner';
export const TABLE_CONTROLLER_ID = 'Table';
